@if (phase() === 'loading') {
	<span
		class="action-skeleton"
		[tuiSkeleton]="true"
		aria-hidden="true"
	></span>
	<p class="sr-only" aria-live="polite">
		{{ 'analysis.summary.loading' | transloco }}
	</p>
} @else if (phase() === 'view') {
	<button
		tuiButton
		type="button"
		size="s"
		appearance="outline"
		data-action="view"
		(click)="onView()"
	>
		{{ 'analysis.summary.view' | transloco }}
	</button>
} @else if (phase() === 'generating') {
	<mar-insight-progress
		[percent]="progressPercent()"
		[text]="progressMessage()"
		[fallback]="'analysis.summary.progress' | transloco"
	/>
} @else {
	<button
		tuiButton
		type="button"
		size="s"
		appearance="outline"
		data-action="generate"
		[disabled]="!canGenerate()"
		(click)="onGenerate()"
	>
		{{ 'analysis.summary.generate' | transloco }}
	</button>
}

<mar-insight-panel
	[open]="panelOpen()"
	[title]="'analysis.summary.title' | transloco"
	[description]="'analysis.summary.description' | transloco"
	[context]="'analysis.summary.context' | transloco"
	[meta]="meta()"
	[message]="narrative()"
	(closed)="onClosePanel()"
/>
